
import Vue from 'vue'
import ActionToast from '@/components/atoms/ActionToast.vue'
import TextToast from '@/components/atoms/TextToast.vue'
import Button from '@/components/atoms/Button.vue'

export default Vue.extend({
  name: 'FormButtons',
  components: {
    ActionToast,
    TextToast,
    Button,
  },
  props: {
    showRequiredFieldsDialog: {
      type: Boolean,
      required: true,
    },
    showNavigationWarning: {
      type: Boolean,
      required: false,
      default: false,
    },
    isSaveDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isRequiredFieldMissing: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasEdits: {
      type: Boolean,
      required: false,
      default: false,
    },
    savedSuccessfully: {
      type: Boolean,
      required: false,
      default: false,
    },
    saveError: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    showDiscardDialog: false,
    displayOnTopOfPage: false,
  }),
  watch: {
    showNavigationWarning: function (newVal: boolean) {
      if (newVal) {
        this.hideOpenDialogues(false)
      }
    },
  },
  methods: {
    getToastProps: function (topOfPageOnly?: boolean) {
      const props = (this.displayOnTopOfPage || topOfPageOnly) ? {
        target: '.information-section',
        mobileTarget: '.information-section',
        anchorPosition: 'top middle',
        selfPosition: 'top middle',
        anchorPositionMobile: 'top middle',
        selfPositionMobile: 'top middle',
        mobileBreakpoint: 1024,
        offsetY: 8,
        offsetYMobile: 32,
      } : {
        target: true,
        anchorPosition: 'bottom right',
        selfPosition: 'top right',
      }
      return props
    },
    hideOpenDialogues: function (hideNavigationWarning = true) {
      this.showDiscardDialog = false
      this.$emit('hideSaveErrorDialog')
      this.$emit('hideRequiredFieldsDialog')
      if (hideNavigationWarning) {
        this.$emit('hideNavigationWarning')
      }
    }
  }
})
